import React from 'react';
import ReactMarkdown from 'react-markdown';

const MarkdownText = ({ markdown, className }) => {
  if (!markdown) return null;

  return (
    <div className={className}>
      <ReactMarkdown
        components={{
          a: ({ node, ...props }) => (
            <a {...props} className="text-orange-600 hover:text-orange-700 underline" />
          ),
          ul: ({ node, ...props }) => <ul {...props} className="list-disc pl-5 space-y-1" />,
          ol: ({ node, ...props }) => <ol {...props} className="list-decimal pl-5 space-y-1" />,
        }}
      >
        {markdown}
      </ReactMarkdown>
    </div>
  );
};

export default MarkdownText;
